<script setup lang="ts">
// Material Symbols `apartment` — a windowed tower block (Figma 20779:5742).
// Distinct on purpose from `real_estate_agent` beside it: this one counts
// buildings, that one marks a brokered value.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <path
      d="M3 21V7H7V3H17V11H21V21H13V17H11V21H3ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z"
    />
  </svg>
</template>
